/*
 * Contract C5 "unseen answers": the answered actions whose `answer.on` is later than the newest
 * user-started run on the thread (`latestRunStartedOn`, an ISO string, or null when the thread has
 * never run). Derived from the actions ledger and thread_run only — never from the `action_answered`
 * events, whose rows expire after 90 days. MindCloud-owned actions are our queue and never count, and
 * neither does an answer Pieve recorded itself at the user's request: it was in the run that wrote it.
 */
const listPieveWorkflowUnseenAnswers = ({ actions = [], latestRunStartedOn = null } = {}) => {
  const boundaryMs = Date.parse(String(latestRunStartedOn || ''));

  return (Array.isArray(actions) ? actions : []).filter((action) => {
    const answeredMs = Date.parse(String(action?.answer?.on || ''));

    return action?.status === 'done' && action?.owner !== 'pieve' && action?.answer?.by !== 'agent' && String(action?.answer?.value || '').trim() !== '' && Number.isFinite(answeredMs) && (!Number.isFinite(boundaryMs) || answeredMs > boundaryMs);
  });
};

export default listPieveWorkflowUnseenAnswers;
